export default "/images/vendor/@coreui/icons/svg/flag/cif-li.svg?3fffab518b00e7042d3eb785bb664c73";